// TODO: actually read from environment variables
export const DEFAULT_OPEN_API_OPTIONS = [
  "https://petstore3.swagger.io/api/v3/openapi.json",
  "https://api-v3.mbta.com/docs/swagger/swagger.json",
]
